(function () {
  'use strict';

  /* @ngdoc object
   * @name bidding
   * @description
   *
   */
  angular
    .module('bidding', [
      'ui.router'
    ]);
}());
